module.exports = __webpack_public_path__ + "img/agaenNo.7d577800.png";